/** Old route names and URL paths → current targets (bookmarks, emails, vision-era links). */

const legacyRouteNameRedirects = [
  ['apps-recruitment-board', 'recruitment-jobs-list'],
  ['apps-ats-jobs-list', 'recruitment-jobs-list'],
  ['apps-recruitment-jobs-list', 'recruitment-jobs-list'],
  ['apps-recruitment-job-view', 'recruitment-job-view'],
  ['apps-recruitment-candidate-view', 'recruitment-candidate-view'],
  ['apps-recruitment-job-apply-form', 'recruitment-job-apply-form'],
  ['apps-recruitment-talent-pool-list', 'recruitment-candidates-list'],
  ['apps-recruitment-talent-pool-entry-view', 'recruitment-candidates-entry-view'],
  ['apps-recruitment-talent-pool-sign-up-form', 'recruitment-candidates-sign-up-form'],
  ['recruitment-talent-pool-list', 'recruitment-candidates-list'],
  ['recruitment-talent-pool-entry-view', 'recruitment-candidates-entry-view'],
  ['recruitment-talent-pool-sign-up-form', 'recruitment-candidates-sign-up-form'],
  ['apps-recruitment-processes-list', 'recruitment-processes-list'],
  ['apps-recruitment-process-view', 'recruitment-process-view'],
  ['apps-employee-list', 'staff-employee-list'],
  ['apps-employee-view', 'staff-employee-view'],
  ['apps-project-list', 'staff-workstations-list'],
  ['apps-project-view', 'staff-workstations-view'],
  ['apps-project-position-view', 'staff-workstations-position-view'],
  ['apps-client-list', 'sale-client-list'],
  ['apps-client-view', 'sale-client-view'],
  ['apps-houses-list', 'logistics-apartments-list'],
  ['apps-house-view', 'logistics-apartments-view'],
  ['apps-house-room-view', 'logistics-apartments-room-view'],
  ['apps-email-templates-list', 'communication-email-list'],
  ['apps-email-template-view', 'communication-email-view'],
  ['apps-default-email-template-view', 'communication-email-default-view'],
  ['apps-company-view', 'settings-organization'],
  ['apps-user-list', 'settings-users-list'],
  ['apps-user-view', 'settings-users-view'],
  ['page-jobs-settings', 'settings-recruitment'],
  ['page-employees-settings', 'settings-employee'],
  ['page-houses-settings', 'settings-apartments'],
  ['page-clients-settings', 'settings-client'],
  ['page-projects-settings', 'settings-workstations'],
].map(([name, redirect]) => ({
  path: `/_legacy/route/${name}`,
  name,
  redirect: { name: redirect },
}))

const legacyPathRedirects = [
  { path: '/ats/job', redirect: '/recruitment/jobs' },
  { path: '/ats/job/:id', redirect: (to) => `/recruitment/jobs/${to.params.id}` },
  { path: '/ats/jobs', redirect: '/recruitment/jobs' },
  { path: '/ats/jobs/:id', redirect: (to) => `/recruitment/jobs/${to.params.id}` },
  { path: '/ats/talent-pool', redirect: '/recruitment/candidates' },
  { path: '/ats/talent-pool/:id', redirect: (to) => `/recruitment/candidates/${to.params.id}` },
  { path: '/recruitment/talent-pool', redirect: '/recruitment/candidates' },
  { path: '/recruitment/talent-pool/:id', redirect: (to) => `/recruitment/candidates/${to.params.id}` },
  { path: '/talent-pool-sign-up', redirect: '/candidates/sign-up' },
  { path: '/templates/workflow', redirect: '/recruitment/processes' },
  { path: '/templates/workflow/:id', redirect: (to) => `/recruitment/processes/${to.params.id}` },
  { path: '/staff/project/position/:id', redirect: (to) => `/staff/workstations/position/${to.params.id}` },
  { path: '/staff/project/:id', redirect: (to) => `/staff/workstations/${to.params.id}` },
  { path: '/staff/project', redirect: '/staff/workstations' },
  { path: '/staff/client/:id', redirect: (to) => `/sale/client/${to.params.id}` },
  { path: '/staff/client', redirect: '/sale/client' },
  { path: '/staff/house/room/:id', redirect: (to) => `/logistics/apartments/room/${to.params.id}` },
  { path: '/staff/house/:id', redirect: (to) => `/logistics/apartments/${to.params.id}` },
  { path: '/staff/house', redirect: '/logistics/apartments' },
  { path: '/templates/email/default/:action', redirect: (to) => `/communication/email/default/${to.params.action}` },
  { path: '/templates/email/:id', redirect: (to) => `/communication/email/${to.params.id}` },
  { path: '/templates/email', redirect: '/communication/email' },
  { path: '/settings/company/user-management/user/:id', redirect: (to) => `/settings/users/${to.params.id}` },
  { path: '/settings/company/user-management', redirect: '/settings/users' },
  { path: '/settings/company/details', redirect: '/settings/organization' },
  { path: '/settings/job', redirect: '/settings/recruitment' },
  { path: '/settings/house', redirect: '/settings/apartments' },
  { path: '/settings/project', redirect: '/settings/workstations' },
]

const legacyRedirects = [
  {
    path: '/_legacy/route/dashboard',
    name: 'dashboard',
    redirect: { name: 'panel-dashboard' },
  },
  {
    path: '/_legacy/route/reminders',
    name: 'reminders',
    redirect: { name: 'panel-reminders' },
  },
  {
    path: '/_legacy/route/ai-assistant',
    name: 'ai-assistant',
    redirect: { name: 'panel-ai-assistant' },
  },
  ...legacyRouteNameRedirects,
  ...legacyPathRedirects,
]

export default legacyRedirects
